(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["notify-me-sold-out"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__lumiNotifyBound) return;
    window.__lumiNotifyBound = true;

    function soldOutLabel() {
      var label = window.variantStrings && window.variantStrings.soldOut;
      return (label || 'Sold out').trim().toLowerCase();
    }

    function buttonIsSoldOut(button) {
      if (!button || !button.hasAttribute('disabled')) return false;
      var span = button.querySelector('span');
      var text = (span ? span.textContent : button.textContent || '').trim().toLowerCase();
      return text === soldOutLabel();
    }

    function phoneDigits(value) {
      var digits = (value || '').replace(/\D/g, '');
      if (digits.length === 12 && digits.indexOf('91') === 0) digits = digits.slice(2);
      if (digits.length === 11 && digits.charAt(0) === '0') digits = digits.slice(1);
      return digits;
    }

    function syncSection(sectionId) {
      var form = document.getElementById('product-form-' + sectionId);
      var opener = document.querySelector('.lumi-notify[data-section-id="' + sectionId + '"]');
      if (!form || !opener) return;
      var addButton = form.querySelector('[name="add"]');
      if (buttonIsSoldOut(addButton)) opener.removeAttribute('hidden');
      else opener.setAttribute('hidden', '');

      var modal = document.getElementById('NotifyModal-' + sectionId);
      var variantInput = form.querySelector('[name="id"]');
      if (!modal || !variantInput) return;
      var variantId = variantInput.value;
      modal.dataset.variantId = variantId;
      var idField = modal.querySelector('.js-notify-variant-id');
      if (idField) idField.value = variantId;
    }

    function syncAll() {
      document.querySelectorAll('.lumi-notify[data-section-id]').forEach(function (opener) {
        syncSection(opener.dataset.sectionId);
      });
    }

    function openSuccessModals() {
      document.querySelectorAll('[data-notify-success]').forEach(function (message) {
        var modal = message.closest('modal-dialog');
        if (modal && typeof modal.show === 'function') modal.show(message);
      });
    }

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('.js-notify-form');
      if (!form) return;
      var phoneInput = form.querySelector('.js-notify-phone');
      var error = form.querySelector('.js-notify-client-error');
      var digits = phoneDigits(phoneInput ? phoneInput.value : '');
      if (digits.length !== 10) {
        event.preventDefault();
        if (error) {
          error.hidden = false;
          error.textContent = 'Enter a 10-digit phone number.';
        }
        if (phoneInput) phoneInput.focus();
        return;
      }
      if (phoneInput) phoneInput.value = digits;
      if (error) error.hidden = true;
      var modal = form.closest('modal-dialog');
      var tags = form.querySelector('.js-notify-tags');
      var productId = modal ? modal.dataset.productId : '';
      var variantId = modal ? modal.dataset.variantId : '';
      if (tags) {
        tags.value = ['notify-me', 'restock-' + productId, 'phone-' + digits, 'variant-' + variantId].join(',');
      }
    });

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data ? event.data : {};
        if (data.sectionId) syncSection(data.sectionId);
        else syncAll();
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      syncAll();
      openSuccessModals();
    });
    syncAll();
    openSuccessModals();
  })();
  } catch(e) { console.error(e); }
})();

})();
